<div
  class="platform-requests-widget-container"
  [class.loading-elements]="loading"
>
  <div class="widget-head">
    <h3 class="widget-title">
      {{
        'platformWidget.admin.platformRequests.widgetMainTextStart' | transloco
      }}
      <markant-spinner class="spinner-element"></markant-spinner>
      <span class="request-count request-count-main">{{
        openRequestsCount
      }}</span>
      <br />
      {{
        'platformWidget.admin.' +
          widgetType +
          '.widgetMainTextEnd' +
          singularity | transloco
      }}
    </h3>
  </div>

  <div class="widget-body">
    <h4 class="widget-status">
      {{ 'platformWidget.admin.platformRequests.requestStatus' | transloco }}
    </h4>

    <div class="widget-statuses">
      <div class="status status-count">
        <markant-spinner class="spinner-element"></markant-spinner>
        <span class="request-count">{{ openRequestsCount }}</span>
        <span class="request-count">{{ inProgressRequestsCount }}</span>
      </div>

      <div class="status status-chips">
        <markant-chip
          class="status-chip"
          [label]="primaryChipText"
          colorScheme="secondary"
        >
          <markant-icon slot="icon-leading" icon="m_new-small"></markant-icon>
        </markant-chip>

        <markant-chip
          class="status-chip"
          [label]="secondaryChipText"
          colorScheme="warning"
        >
          <markant-icon
            slot="icon-leading"
            icon="m_password-show"
          ></markant-icon>
        </markant-chip>
      </div>
    </div>
  </div>
</div>
